// extracted by mini-css-extract-plugin
module.exports = {"view-slider-item-details":"styles__view-slider-item-details__3b2XI","viewSliderItemDetails":"styles__view-slider-item-details__3b2XI"};